import {
  checkoutStreamingWithCredit,
  checkoutSubscription
} from "./chunk-G2W27D3E.mjs";

// src/hooks/wbk/subscriptions/checkout.ts
import { useMutation } from "@tanstack/react-query";
var useCheckoutSubscription = () => {
  return useMutation({
    mutationFn: checkoutSubscription
  });
};
var useCheckoutStreamWithCredit = () => {
  return useMutation({
    mutationFn: checkoutStreamingWithCredit
  });
};

export {
  useCheckoutSubscription,
  useCheckoutStreamWithCredit
};
//# sourceMappingURL=chunk-3XOZJTYR.mjs.map